module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//ready_bottom.jpg?v=ad49b72d";